export type VersionNumber = {
    major: number;
    incremental: number;
    createdAt: string;
};

export const APP_VERSION: VersionNumber = {
    major: 2,
    incremental: 114,
    createdAt: '2026-10-10',
};

const buildTimeFromEnvironment = process.env.REACT_APP_BUILD_TIME;

export const BUILD_TIME: string = buildTimeFromEnvironment && buildTimeFromEnvironment.trim().length > 0
    ? buildTimeFromEnvironment
    : 'local';

export const PAGE_VERSIONS = {
    home: { major: 2, incremental: 2, createdAt: '2026-09-16 00:00' },
    search: { major: 2, incremental: 1, createdAt: '2026-09-16 00:00' },
    menu: { major: 2, incremental: 49, createdAt: '2026-10-10' },
    orders: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
    menuEditing: { major: 2, incremental: 34, createdAt: '2026-10-01 21:07' },
    foodMakersStatus: { major: 2, incremental: 6, createdAt: '2026-09-22 00:09' },
    telegramLinkConverter: { major: 2, incremental: 1, createdAt: '2026-09-22 00:09' },
    productEditing: { major: 2, incremental: 9, createdAt: '2026-09-16 00:00' },
    rootRedirect: { major: 2, incremental: 1, createdAt: '2026-09-21 12:55' },
    unknown: { major: 2, incremental: 0, createdAt: '2026-06-24 17:10' },
} satisfies Record<string, VersionNumber>;

const ROUTE_VERSION_KEYS: Array<{ path: string; pageKey: keyof typeof PAGE_VERSIONS }> = [
    { path: '/Home', pageKey: 'home' },
    { path: '/Search', pageKey: 'search' },
    { path: '/Menu', pageKey: 'menu' },
    { path: '/menu', pageKey: 'menu' },
    { path: '/orders', pageKey: 'orders' },
    { path: '/MenuEditing', pageKey: 'menuEditing' },
    { path: '/FoodMakersStatus', pageKey: 'foodMakersStatus' },
    { path: '/TelegramLinkConverter', pageKey: 'telegramLinkConverter' },
    { path: '/ProductEditing', pageKey: 'productEditing' },
    { path: '/FoodMakersStatus', pageKey: 'foodMakersStatus' },
    { path: '/', pageKey: 'rootRedirect' },
];

export function formatVersion(version: VersionNumber): string {
    return `${version.major}.${version.incremental}`;
}

export function getPageVersionForPath(pathname: string): VersionNumber {
    const normalizedPath = pathname.endsWith('/') && pathname !== '/'
        ? pathname.slice(0, -1)
        : pathname;
    const matchedRoute = ROUTE_VERSION_KEYS.find((routeVersion) => routeVersion.path === normalizedPath);

    return matchedRoute ? PAGE_VERSIONS[matchedRoute.pageKey] : PAGE_VERSIONS.unknown;
}
